// extracted by mini-css-extract-plugin
export default {"productBlockWrapper":"productBlock_productBlockWrapper__xHs1K","productCommonTitle":"productBlock_productCommonTitle__mTDMX"};